__turbopack_context__.v({
  "container": "no-results-module-scss-module__F16OLG__container",
  "title": "no-results-module-scss-module__F16OLG__title",
});
